module.exports = __webpack_public_path__ + "static/media/pics3.f9f34af6.jpg";